var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function () {
        return [_c('sub-visual', {
          attrs: {
            "title": "마이페이지",
            "src": "/images/sub/sv-mypage.jpg"
          }
        })];
      },
      proxy: true
    }, {
      key: "contentsImmersive",
      fn: function () {
        return [_c('mypage-navigation-row')];
      },
      proxy: true
    }])
  }, [_c('v-container', [_c('v-data-table', _vm._b({
    staticClass: "v-data-table--default",
    attrs: {
      "hide-default-footer": "",
      "disable-filtering": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.state`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('v-chip', {
          staticClass: "w-80px w-md-100px w-lg-120px",
          attrs: {
            "x-small": "",
            "label": "",
            "dark": "",
            "color": _vm.stateColor(item)
          }
        }, [_vm._v(_vm._s(_vm.stateText(item)))])];
      }
    }, {
      key: `item.cancel`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('v-btn', {
          staticClass: "w-80px w-md-100px w-lg-120px",
          attrs: {
            "disabled": !_vm.isCancelable(item),
            "x-small": "",
            "color": "pink lighten-1"
          },
          on: {
            "click": function ($event) {
              return _vm.cancel(item);
            }
          }
        }, [_vm._v("신청취소")])];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('pagination-component', {
          attrs: {
            "value": _vm.page,
            "count": _vm.pageCount
          },
          on: {
            "input": function (page) {
              return _vm.$router.push({
                query: {
                  page
                }
              });
            }
          }
        })];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }